import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable, of} from 'rxjs';
import {UrlService} from "../url.service";

@Injectable()
export class FormService {
    private BASE_URL: string;
    private formTypes = null;
    private formsSystemEnabled;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/forms';
    }

    listForms(params) {
        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL, requestOptions);
    }

    loadForm(formId): Observable<any> {
        return this.http.get(this.BASE_URL + '/' + formId);
    }

    saveForm(form) {
        return this.http.put(this.BASE_URL + '/' + form.id, form);
    }

    createForm(clientId, formTypeCode) {
        return this.http.get(this.BASE_URL + '/create/' + clientId + '/' + formTypeCode);
    }

    deleteForms(formIds) {
        let params = new HttpParams();

        params = params.set('formIds', formIds);

        const requestOptions = {
            params: params
        };

        return this.http.delete(this.BASE_URL, requestOptions);
    }

    deleteForm(form) {
        return this.http.delete(this.BASE_URL + '/' + form.id);
    }

    getInitialData(clientId, formTypeCode, params) {
        return this.http.post(this.BASE_URL + '/initialize/' + clientId + '/' + formTypeCode, params);
    }

    generateFormData(clientId, formTypeCode, formParams) {
        return this.http.post(this.BASE_URL + '/generate/' + clientId + '/' + formTypeCode, formParams);
    }

    getFormTypes() {
        if (this.formTypes) {
            return of(this.formTypes);
        } else {
            return this.http.get(this.BASE_URL + '/types').pipe(
                map((types) => {
                    this.formTypes = types;
                    return types;
                })
            );
        }
    }

    isFormSystemEnabled() {
        if (this.formsSystemEnabled !== undefined) {
            return of(this.formsSystemEnabled);
        } else {
            return this.http.get(this.BASE_URL + '/available').pipe(
                map((enabled) => {
                    this.formsSystemEnabled = enabled;
                    return enabled;
                })
            );
        }
    }
}
